import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { mediaQueryHOC } from "../../adapters/helpers/Hooks";
import Block from "../../adapters/helpers/Block";
import DOMPurify from 'isomorphic-dompurify';
import { scrollIntoView } from '../../adapters/helpers/Scroll';

function StartGuideWrapper(props) {
  const { document } = props;
  const relatedBlocks = document.fields.relatedBlocks || [];
  const ioPages = document.fields.ioPages || [];
  const [currentPage, setCurrentPage] = useState(ioPages[0].fields.id);
  const [selectedOption, setSelectedOption] = useState(0);

  function DropDownSelector({ options, selectedOption, anchorId }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropDownRef = useRef();

    useEffect(() => {
      if (window?.location?.hash === `#${anchorId}` && dropDownRef?.current) {
        let timeout = null;
        window.setTimeout(() => {
          timeout = scrollIntoView(dropDownRef.current, { behavior: 'smooth', block: 'nearest' });
        }, 250);

        return () => {
          clearTimeout(timeout);
        }
      }
    }, []);

    const toggleDropDown = () => {
      setIsOpen(!isOpen);
    }

    const handleOptionClick = (index) => {
      setSelectedOption(index);
      setCurrentPage(ioPages[index]?.fields?.id);
    };

    return (
      <div ref={dropDownRef} className={`select-component ${isOpen ? 'open' : ''}`}>
        <div className="select-component-header dropdownSelector custom-dropdown" onClick={toggleDropDown}>
          <span className="options-selected">{options[selectedOption]?.fields?.label}</span>
        </div>
        {isOpen && (
          <ul className="select-component-options options-io">
            {options.map((option, index) => (
              <li
                key={index}
                onClick={() => {
                  handleOptionClick(index);
                  toggleDropDown();
                }}
              >
                {option?.fields?.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  const handleOptionClick = (index) => {
    setSelectedOption(index);
    setCurrentPage(ioPages[index]?.fields?.id);
  };
  return (
    <div className="start-guide-wrapper">
      {new Block(relatedBlocks).renderSpecifiedBlock(relatedBlocks)}
      {document.fields.dropDownReference &&
        (<section className="dropdownSelector-section">
          <div className="dropdownSelector-section-content">
            <h2 className="dropdown-header" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(document.fields.dropDownReference.fields.title) }} />
            <p className="dropdown-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(document.fields.dropDownReference.fields.description) }} />
            <div className="dropdown-block">
              <p className="dropdownblock" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(document.fields.dropDownReference.fields.dropDownTiltle) }} />

              <DropDownSelector
                options={document.fields.dropDownReference.fields.dropDownItems.map((item, index) => ({
                  fields: { label: item },
                }))}
                selectedOption={selectedOption}
                anchorId="dropdownSelector"
                handleOptionClick={handleOptionClick}
              />
            </div>
          </div>
        </section>)
      }
      {ioPages
        .filter(page => page.fields.id === currentPage)
        .map(filteredPage => new Block([filteredPage]).renderSpecifiedBlock([filteredPage]))
      }
    </div>
  );
}

export default mediaQueryHOC(StartGuideWrapper);

StartGuideWrapper.propTypes = {
  className: PropTypes.string,
  extraAttributes: PropTypes.any,
  isMedium: PropTypes.any,
  customEvent: PropTypes.any,
  onClickCallback: PropTypes.func,
};
